import axios from '@/utils/api'
import modulo from '@/utils/modulo'
import FileSaver from 'file-saver'

const URL_GESTAO_DE_DOCUMENTOS = `${modulo.GESTAO_DE_DOCUMENTOS}`

const actions = {
  async download ({ commit }, data) {
    const file = await axios({
      method: 'POST',
      responseType: 'blob',
      url: `${URL_GESTAO_DE_DOCUMENTOS}/download`,
      data
    })

    FileSaver.saveAs(file, `${data.nome}.${data.formato}`)
  },

  async getBytesDocumento ({ commit }, documento) {
    const data = await axios({
      method: 'POST',
      responseType: 'arraybuffer',
      url: `${URL_GESTAO_DE_DOCUMENTOS}/download`,
      data: documento
    })

    return data
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/gestaoDocumentos/gestaoDocumentos.js